module.exports = __webpack_public_path__ + "img/slider8.174d09a0.png";